// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"14ee1fb2","348":"f9e29927","361":"1650504a","541":"119375d0","723":"35b3b285","862":"f665e253","961":"85bd2c61"}[chunkId] + ".chunk.js";
};